import { Component, OnInit } from '@angular/core'; 

//https://www.privacypolicies.com/blog/google-api-privacy-policy/
@Component({
    selector: 'privacy',
    templateUrl: './privacy.component.html',
    styleUrls: ['./../regulations.less']
})
export class PrivacyComponent {
   
}
